<template lang="pug">
  .component-reservation-requests
    .dropdown-buttons
      //GroupReveal(:groupProp="item", @refresh="$emit('refresh')")
      ModalReveal(:ref="modal")
        a(slot="trigger", @click="search") Create Booking
        .row
          .column
            Driver(:item="item.driver", type="driver-card" )
          .column
            .row
              .column
                label Dates
                div From: {{$dateFormat(item.start, 'DD MMM YYYY HH:mm')}} - {{item.pick_up.name}}
                div To: {{$dateFormat(item.end, 'DD MMM YYYY HH:mm')}}  - {{item.drop_off.name}}
            .row

              .column
                .label Passengers
                .value {{item.flags.passengers}}
              .column
                label Offroad
                span.fa(:class='{"offroad": item.flags.offroad ,"fa-times":!item.flags.offroad,"fa-check":item.flags.offroad} ')
            .row
              .column
                label Notes
                .field-value {{item.notes}}
        .row
          .column
            h2 Select the vehicle
            template(v-if="slots.length === 0 && !loading")
              h2.text-center No available vehicles
            vehicle(v-for="(vehicle, id) in slots", :key="id", :item="vehicle", v-if="!vehicle.disabled",  type="search-result", @bookVehicle="bookNow")

</template>

<script>
import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
import ModalReveal from '../../foundation/ModalReveal'
import ActionButton from '../ActionButton'
import GroupReveal from '../../../../pages/backoffice/GroupEdit'
import Driver from "../../../backoffice/Driver.vue";
import SelectizeParkingLot from "../lists/selectize/SelectizeParkingLot.vue";
import KeplerBackofficeSdk from "../../../../lib/kepler/backoffice";
import collect from "collect.js";
import Vehicle from 'components/backoffice/Vehicle'
import MaggieHelper from "../../../../maggieHelper";

export default {
  name: 'CreateBookingFromReservationRequest',
  components: {Vehicle, SelectizeParkingLot, Driver, GroupReveal, PolicyReveal, ActionButton, ModalReveal},
  data() {
    return {
      slots: [],
      loading: false
    }
  },
  created() {
  },
  methods: {
    collect,
    search() {
      this.loading = true
      return KeplerBackofficeSdk.parkingSlots.list.slots(this.item.flags.pick_up_id, (data) => {
        this.slots = collect(data).filter((vs) => vs.vehicle_slot != null).pluck('vehicle_slot').map((vs) => vs.vehicle).all()
        this.loading = false
      })
    },
    bookNow(vehicle) {
      KeplerBackofficeSdk.reservations.makeDriverRequestBooking(this.item.id, {plate: vehicle.plate}, (response) => {
        MaggieHelper.notification('book-esit', 'reservation created')
        this.$refs[this.modal].close()
        this.$router.push({name: 'reservation', params: {id: response.id}})

      })
    },
  },
  computed: {
    modal() {
      return `modal-${this._uid}`
    },

  },
  props: ['item', 'driver']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateBookingFromReservationRequest.vue?7ffeb02a